import { useEffect, useState } from "react";
import {
  emailValidation,
  getPhoneNumberLimits,
  handlePhoneNoChange,
  nameValidation,
  passwordValidation,
  phoneNumberFormat,
  phoneNumberValidation,
} from "../../Common/Validations";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ConfirmModel } from "../../Model/ConfirmModel";
import { setUnsavedChanges } from "../../Redux/Slice/Common/SelectedTabSlice";
import { ALL_CALLING_CODES } from "../../Common/Constants";
import { maskNoByCallingCode } from "../../Common/utils";
import CountryPhoneInput from "../../Common/CountryPhoneInput";

export const AdminDetails = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const formData = props?.adminDetails;
  const setFormData = props?.setAdminDetails;
  const formError = props?.adminFormError;
  const setFormError = props?.setAdminFormError;
  const [hasChnaged, setHasChanged] = useState(false);
  const [confirmModel, setCOnfirmModel] = useState(false);

  useEffect(() => {
    if (props?.isEdit === true) {
      const data = props.customerDetails;
      if (props.customerDetails) {
        setFormData({
          id: data.id,
          firstName: data?.admin?.firstName,
          lastName: data?.admin?.lastName,
          email: data?.admin?.email,
          countryCallingCode: data?.admin?.countryCallingCode
            ? data?.admin?.countryCallingCode
            : "+61",
          phoneNumber: data?.admin?.phoneNumber
            ? data?.admin?.phoneNumber
            : "",
          roleId: "QSZkx4V308", //TODO: update dynamic
        });
      }
    }
  }, [props.customerDetails]);
  const handleChange = async (e) => {
    let { name, value } = e.target;
    value = value.trimStart();
    setHasChanged(true);
    dispatch(setUnsavedChanges(true));
    if (name === "email") {
      value = value.trimEnd();
      const isValid = emailValidation(value);
      setFormData({ ...formData, [name]: value.trimStart() });
      if (isValid) {
        setFormError({ ...formError, emailError: "" });
      } else {
        setFormError({ ...formError, emailError: "Please enter valid Email" });
      }
    } else if (name === "firstName") {
      const valid = nameValidation(value);
      if (valid || value.trim() == "") {
        setFormError({
          ...formError,
          firstNameError: "",
        });
      } else {
        setFormError({
          ...formError,
          firstNameError: "Please enter valid name",
        });
      }
      let capitalized = value.charAt(0).toString().toUpperCase();
      value = capitalized + value.substring(1);
      setFormData({ ...formData, [name]: value });
    } else if (name === "lastName") {
      const valid = nameValidation(value);
      if (valid || value.trim() == "") {
        setFormError({
          ...formError,
          lastNameError: "",
        });
      } else {
        setFormError({
          ...formError,
          lastNameError: "Please enter valid name",
        });
      }
      let capitalized = value.charAt(0).toString().toUpperCase();
      value = capitalized + value.substring(1);
      setFormData({ ...formData, [name]: value });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = () => {
    props.setAdminDetails(formData);
    props.handleSubmit(formData);
  };

  const handleCountryCodeChange = async (e) => {
    const { name, value } = e.target;
    setHasChanged(true);
    dispatch(setUnsavedChanges(true));
    let formatted = formData.phoneNumber
    setFormData({ ...formData, [name]: value, phoneNumber: formatted });
    const minDigits = getPhoneNumberLimits(value)?.min ?? 10;
    const rawDigits = formData.phoneNumber.replace(/\D/g, "");
    const isValid = phoneNumberValidation(rawDigits, value);
    setFormError({
      ...formError,
      phoneError:
        isValid || value === ""
          ? ""
          : rawDigits.length < minDigits
          ? `Phone number must be at least ${minDigits} digits long.`
          : "Please enter a valid phone number",
    });
  };

  const handlePhoneChange = async (e) => {
    let { name, value } = e.target;
    handlePhoneNoChange(
      e,
      formData.countryCallingCode,
      () => setFormData({ ...formData, [name]: value }),
      (newError) => setFormError({ ...formError, phoneError: newError }),
      (isChanged) => {
        setHasChanged(isChanged);
        dispatch(setUnsavedChanges(true));
      },
      false
    );
  };
  const handelNo = () => {
    setCOnfirmModel(false);
  };
  const handleCancel = () => {
    setCOnfirmModel(false);
    dispatch(setUnsavedChanges(false));
    navigate("/customers");
  };
  return (
    <div
      className={
        props.selectedTab === 2
          ? "tabsContent__content tabsContent__content--selected"
          : "tabsContent__content"
      }
    >
      {confirmModel ? (
        <ConfirmModel
          onAccept={handleCancel}
          yes={"Yes"}
          no={"No"}
          onReject={handelNo}
          title="Update Changes!"
          message="Changes made will not be saved. Are you sure you want to leave the page?"
        />
      ) : (
        ""
      )}
      <div className="details">
        <div className="form">
          <section className="form__section">
            <h1 className="form__section__title">Admin Details</h1>
            <div className="formRow formRow__2">
              <div className="formCol">
                <div className="form__Field">
                  <label for="firstname" className="form__label">
                    First Name <span style={{ color: "red" }}> * </span>
                  </label>
                  <input
                    type="text"
                    id="firstname"
                    name="firstName"
                    maxLength={30}
                    onChange={handleChange}
                    value={formData.firstName}
                    className="form__input form__input--sm"
                    placeholder="First Name"
                  />
                </div>
                <div className="form__error">{formError.firstNameError}</div>
              </div>
              <div className="formCol">
                <div className="form__Field">
                  <label for="lastname" className="form__label">
                    Last Name <span style={{ color: "red" }}> * </span>
                  </label>
                  <input
                    type="text"
                    id="lastname"
                    maxLength={30}
                    name="lastName"
                    onChange={handleChange}
                    value={formData.lastName}
                    className="form__input form__input--sm"
                    placeholder="Last Name"
                  />
                </div>
                <div className="form__error">{formError.lastNameError}</div>
              </div>
            </div>
            <div className="formRow formRow__2">
              <div className="formCol">
                <div className="form__Field">
                  <label for="email" className="form__label">
                    Email <span style={{ color: "red" }}> * </span>
                  </label>
                  <input
                    type="text"
                    id="email"
                    name="email"
                    maxLength={100}
                    onChange={handleChange}
                    value={formData.email}
                    disabled={props.isEdit}
                    className={
                      props.isEdit
                        ? "form__input form__input--sm form__input--disabled"
                        : "form__input form__input--sm"
                    }
                    placeholder="Email"
                  />
                  <div className="form__error">{formError.emailError}</div>
                </div>
              </div>
              <div className="formCol">
                <div className="form__Field">
                  <label for="phonenumber" className="form__label">
                    Phone Number <span style={{ color: "red" }}> * </span>
                  </label>
                  <CountryPhoneInput
                    countryCodeFieldName="countryCallingCode"
                    phoneFieldName="phoneNumber"
                    countryCode={formData?.countryCallingCode}
                    phoneNumber={formData?.phoneNumber}
                    onCountryChange={handleCountryCodeChange}
                    onPhoneChange={handlePhoneChange}
                  />
                  <div className="form__error">{formError.phoneError}</div>
                </div>
              </div>
            </div>
            <div className="btn__group">
              <button
                className="btn btn__white"
                type="button"
                onClick={() => {
                  if (hasChnaged) {
                    setCOnfirmModel(true);
                  } else {
                    navigate("/customers");
                    dispatch(setUnsavedChanges(false));
                  }
                }}
              >
                Cancel
              </button>
              {props.isEdit ? (
                <button
                  className="btn btn__primary"
                  type="submit"
                  disabled={
                    !hasChnaged ||
                    formData.firstName === "" ||
                    formError.firstNameError != "" ||
                    formError.lastNameError != "" ||
                    formData.email === "" ||
                    formError.emailError != "" ||
                    formError.phoneError != "" ||
                    formData.phoneNumber === ""
                  }
                  onClick={() => {
                    props.handleSubmit(formData);
                  }}
                >
                  Update
                </button>
              ) : (
                <button
                  className="btn btn__primary"
                  type="submit"
                  disabled={
                    formData.firstName.trim() === "" ||
                    formData.lastName.trim() === "" ||
                    formData.email === "" ||
                    formError.emailError != "" ||
                    formError.phoneError != "" ||
                    formData.phoneNumber === ""
                  }
                  onClick={() => {
                    // props.setAdminDetails(formData);
                    props.setSelectedTab(3);
                  }}
                >
                  Next
                </button>
              )}
              {props?.isEdit ? (
                <button
                  className="btn btn__primary"
                  type="submit"
                  onClick={() => {
                    props.revokeMFA();
                  }}
                >
                  Revoke MFA
                </button>
              ) : null}
              {props?.isEdit &&
              !props?.customerDetails?.admin?.googleUserId &&
              props?.customerDetails?.user?.isInvited ? (
                <button
                  className="btn btn__primary"
                  type="submit"
                  onClick={() => {
                    props?.resendInvitation();
                  }}
                >
                  Resend Invitation
                </button>
              ) : null}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};
